import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "colour-picker n-input" }
const _hoisted_2 = { class: "colour-picker__wrapper" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "colour-picker__input-wrapper" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "colour-picker__trigger" }
const _hoisted_7 = ["id"]
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}

import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import Pickr from '@simonwep/pickr';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-colour-picker',
},
  __name: 'colour-picker',
  props: {
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  modelValue: {
    type: String,
    default: '#062B80',
  },
  errorMessage: {
    type: String,
  },
  hideLabel: {
    type: String,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {



const props = __props;

const { inputId } = useIdGenerator(props.id);

const emit = __emit;

const currentColour = useVModel(props, 'modelValue', emit);

let pickr: Pickr | undefined;
const pickerHost = ref<HTMLElement | null>(null);

onMounted(() => {
  if (!pickerHost.value) {
    // If the host element isn't defined, just return.
    return;
  }
  pickr = Pickr.create({
    el: pickerHost.value,
    theme: 'monolith',
    lockOpacity: true,
    default: currentColour.value,
    position: 'bottom-start',

    components: {
      preview: false,
      opacity: false,
      hue: true,
      interaction: {
        clear: false,
        input: false,
        save: false,
      },
    },
  });

  pickr.on('change', (colour: any, instance: any) => {
    // fires 'save' event
    pickr?.applyColor();
  });

  pickr.on('save', (colour: any, instance: any) => {
    currentColour.value = colour.toHEXA().toString();
  });
});

onBeforeUnmount(() => {
  if (pickr) {
    pickr.destroyAndRemove();
  }
});

watch(currentColour, () => pickr?.setColor(currentColour.value));

function setColour(colour: string) {
  // fires 'change' event
  if (!pickr?.setColor(colour)) {
    currentColour.value = colour;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        for: _unref(inputId),
        class: _normalizeClass(["colour-picker__label", { 'sr-only': __props.hideLabel }])
      }, _toDisplayString(__props.label), 11, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "colour-picker__input",
          type: "text",
          id: _unref(inputId),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentColour) ? (currentColour).value = $event : null)),
          onBlur: _cache[1] || (_cache[1] = (e) => setColour((e.target as HTMLInputElement).value)),
          maxlength: "7"
        }, null, 40, _hoisted_5), [
          [_vModelText, _unref(currentColour)]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            id: __props.id + '__trigger',
            ref_key: "pickerHost",
            ref: pickerHost
          }, null, 8, _hoisted_7)
        ])
      ]),
      (__props.errorMessage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.errorMessage), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})